import { RootState } from "@/app/stores"
import { IEarnRequest, IDebitRequest, debit, createEarnApplication } from "@/shared/api/trading"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const earnBonuses = createAsyncThunk<
    void,
    IEarnRequest,
    { state: RootState }
>('tradingTransfer/earnBonuses', async (data, thunkAPI) => {
    try {
        const response = await createEarnApplication(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const debitBonuses = createAsyncThunk<
    void,
    IDebitRequest,
    { state: RootState }
>('tradingTransfer/debitBonuses', async (data, thunkAPI) => {
    try {
        const response = await debit(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
